import { __assign } from 'tslib';
import React__default, { Fragment } from 'react';
import { KpkMetaFieldType, dayjs } from '@keepeek/commons';
import { Skeleton, Typography, Chip, Box } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import sanitizeHtml from 'sanitize-html';
import FolderLink from '../FolderLink/index.js';
import SanitizeHtml from '../SanitizeHtml/index.js';
import StyledElementMetaField, { classes } from './index.styled.js';

var ElementMetaField = function (_a) {
    var field = _a.field, summaryDisplay = _a.summaryDisplay, _b = _a.showTitle, showTitle = _b === void 0 ? true : _b, _c = _a.showThesaurusDescriptionInTitle, showThesaurusDescriptionInTitle = _c === void 0 ? false : _c, _d = _a.disableClamping, disableClamping = _d === void 0 ? false : _d, className = _a.className, id = _a.id, _e = _a.testId, testId = _e === void 0 ? "ElementMetaField" : _e, onClick = _a.onClick, sx = _a.sx, KIcon = _a.KIcon;
    if (field.loading) {
        return React__default.createElement(Skeleton, { animation: "wave" });
    }
    else {
        var fieldValue = void 0;
        switch (field.type) {
            case KpkMetaFieldType.Text:
            case KpkMetaFieldType.Thesaurus:
            case KpkMetaFieldType.Number:
            case KpkMetaFieldType.MultipleList:
            case KpkMetaFieldType.SimpleList:
            case KpkMetaFieldType.Email:
            case KpkMetaFieldType.URL:
            case KpkMetaFieldType.Geo:
                fieldValue = (React__default.createElement(ElementMetaFieldTextValue, { field: field, spaceIfEmpty: summaryDisplay, ellipsis: summaryDisplay, showTitle: showTitle, showThesaurusDescriptionInTitle: showThesaurusDescriptionInTitle, disableClamping: disableClamping, className: clsx("ElementMetaField-fieldValue", "ElementMetaField-fieldValue-".concat(field.name)), onClick: onClick }));
                break;
            case KpkMetaFieldType.TextArea:
                fieldValue = (React__default.createElement(ElementMetaFieldTextareaValue, { field: field, spaceIfEmpty: summaryDisplay, ellipsis: summaryDisplay, disableClamping: disableClamping, showTitle: showTitle, className: clsx("ElementMetaField-fieldValue", "ElementMetaField-fieldValue-".concat(field.name)) }));
                break;
            case KpkMetaFieldType.Date:
                fieldValue = (React__default.createElement(ElementMetaFieldDateValue, { field: field, format: "LL", spaceIfEmpty: summaryDisplay, ellipsis: summaryDisplay, showTitle: showTitle, className: clsx("ElementMetaField-fieldValue", "ElementMetaField-fieldValue-".concat(field.name)) }));
                break;
            case KpkMetaFieldType.Datetime:
                fieldValue = (React__default.createElement(ElementMetaFieldDateValue, { field: field, format: "LLL", spaceIfEmpty: summaryDisplay, ellipsis: summaryDisplay, showTitle: showTitle, className: clsx("ElementMetaField-fieldValue", "ElementMetaField-fieldValue-".concat(field.name)) }));
                break;
            case KpkMetaFieldType.Folder:
                fieldValue = (React__default.createElement(FolderLink, { className: clsx("ElementMetaField-fieldValue", "ElementMetaField-fieldValue-".concat(field.name)), title: field.name, KIcon: KIcon }, field.value));
                break;
            case KpkMetaFieldType.CheckBox:
                fieldValue = (React__default.createElement(ElementMetaFieldCheckboxValue, { field: field, spaceIfEmpty: summaryDisplay, ellipsis: summaryDisplay, showTitle: showTitle, className: clsx("ElementMetaField-fieldValue", "ElementMetaField-fieldValue-".concat(field.name)) }));
                break;
            default:
                console.error("this field type ".concat(field.type, " is not implemented"));
        }
        return (React__default.createElement(StyledElementMetaField, { "data-testid": testId, id: id, className: clsx("ElementMetaField", "ElementMetaField-".concat(field.name), field.type, className), sx: sx },
            !summaryDisplay && showTitle && (React__default.createElement(Typography, { variant: "caption", color: "textSecondary", className: classes.firstLetterUpper }, field.name)),
            fieldValue));
    }
};
var ElementMetaFieldCheckboxValue = function (_a) {
    var field = _a.field, ellipsis = _a.ellipsis, showTitle = _a.showTitle;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(ElementMetaFieldValueWrapper, { ellipsis: ellipsis, clamp: field.id === "title", bold: field.id === "title", title: "".concat(field.name, ": ").concat(field.value), className: clsx("ElementMetaFieldCheckboxValue", "ElementMetaFieldCheckboxValue-".concat(field.name)), showTitle: showTitle },
        React__default.createElement(Chip, { className: "ElementMetaFieldCheckboxValue-Chip", variant: "outlined", size: "small", label: field.value
                ? t("components.element-metafield-checkbox.label.yes")
                : t("components.element-metafield-checkbox.label.no") })));
};
var ElementMetaFieldTextValue = function (_a) {
    var field = _a.field, ellipsis = _a.ellipsis, spaceIfEmpty = _a.spaceIfEmpty, onClick = _a.onClick, showTitle = _a.showTitle, showThesaurusDescriptionInTitle = _a.showThesaurusDescriptionInTitle, disableClamping = _a.disableClamping;
    var t = useTranslation("refront-components").t;
    if ((Array.isArray(field.value) && field.value.length === 0 && spaceIfEmpty) ||
        (!field.value && spaceIfEmpty)) {
        return null;
    }
    if (Array.isArray(field.value)) {
        return (React__default.createElement(ElementMetaFieldValueWrapper, { ellipsis: ellipsis, className: clsx("ElementMetaFieldTextValue", "ElementMetaFieldTextValue-".concat(field.name)) },
            React__default.createElement("div", { className: clsx("ElementMetaFieldTextValue-Box", classes.thesaurus) }, field.value.map(function (v) {
                var title = showThesaurusDescriptionInTitle &&
                    field.descriptionByValue &&
                    field.descriptionByValue[v]
                    ? t("components.element-metafield-text.title.with-description", {
                        fieldName: field.name,
                        valueDescription: field.descriptionByValue[v]
                    })
                    : t("components.element-metafield-text.title", {
                        fieldName: field.name,
                        value: v
                    });
                return (React__default.createElement(Chip, __assign({ key: "".concat(field.id, "-chip-").concat(v), title: showTitle ? title : undefined, "data-testid": "".concat(field.id, "-chip-").concat(v), size: "small", label: v, onDoubleClick: function (e) {
                        e.stopPropagation();
                    } }, (onClick
                    ? {
                        onClick: function (e) {
                            onClick(v);
                            e.stopPropagation();
                        }
                    }
                    : null))));
            }))));
    }
    return (React__default.createElement(ElementMetaFieldValueWrapper, { ellipsis: ellipsis, clamp: !disableClamping && field.id === "title", bold: field.id === "title", title: sanitizeHtml("".concat(field.name, ": ").concat(field.value), {
            allowedTags: []
        }), className: clsx("ElementMetaFieldTextValue", "ElementMetaFieldTextValue-".concat(field.name)), showTitle: showTitle },
        React__default.createElement(SanitizeHtml, { html: field.value })));
};
var ElementMetaFieldTextareaValue = function (_a) {
    var field = _a.field, ellipsis = _a.ellipsis, spaceIfEmpty = _a.spaceIfEmpty, showTitle = _a.showTitle, disableClamping = _a.disableClamping;
    var val;
    if (field.value && !Array.isArray(field.value)) {
        if (disableClamping) {
            val = field.value.split("\n").map(function (line, id) {
                return (React__default.createElement(Fragment, { key: id },
                    React__default.createElement(SanitizeHtml, { html: line })));
            });
        }
        else {
            val = React__default.createElement(SanitizeHtml, { html: field.value.split("\n")[0] });
        }
    }
    if (!val && spaceIfEmpty) {
        return null;
    }
    var title = "".concat(field.name, ": ").concat((!Array.isArray(field.value)
        ? field.value
        : field.value.join(" "))
        .split("\n")
        .join(" "));
    return (React__default.createElement(ElementMetaFieldValueWrapper, { ellipsis: ellipsis, clamp: !disableClamping, title: sanitizeHtml(title, {
            allowedTags: []
        }), className: clsx("ElementMetaFieldTextareaValue", "ElementMetaFieldTextareaValue-".concat(field.name)), showTitle: showTitle }, val));
};
var ElementMetaFieldDateValue = function (_a) {
    var field = _a.field, format = _a.format, ellipsis = _a.ellipsis, spaceIfEmpty = _a.spaceIfEmpty, showTitle = _a.showTitle;
    var val;
    if (field.value && !Array.isArray(field.value)) {
        val = dayjs(field.value).format(format);
    }
    if (!val && spaceIfEmpty) {
        return null;
    }
    return (React__default.createElement(ElementMetaFieldValueWrapper, { className: clsx("ElementMetaFieldDateValue", "ElementMetaFieldDateValue-".concat(field.name)), ellipsis: ellipsis, title: "".concat(field.name, ": ").concat(val), showTitle: showTitle }, val));
};
var ElementMetaFieldValueWrapper = function (_a) {
    var title = _a.title, ellipsis = _a.ellipsis, children = _a.children, _b = _a.clamp, clamp = _b === void 0 ? false : _b, _c = _a.bold, bold = _c === void 0 ? false : _c, className = _a.className, _d = _a.showTitle, showTitle = _d === void 0 ? true : _d, _e = _a.testId, testId = _e === void 0 ? "ElementMetaFieldValueWrapper" : _e;
    if (children) {
        return (React__default.createElement(Box, { title: showTitle ? title : undefined, textOverflow: ellipsis ? "ellipsis" : undefined, overflow: ellipsis ? "hidden" : undefined, whiteSpace: ellipsis && !clamp ? "nowrap" : undefined, fontWeight: bold ? 500 : "normal", "data-testid": testId, className: clsx("ElementMetaFieldValueWrapper", clamp && classes.clamping, ellipsis && !clamp && classes.ellipsis, className), sx: { marginBottom: function (theme) { return theme.spacing(1); } } }, children));
    }
    return null;
};

export { ElementMetaField, ElementMetaField as default };
//# sourceMappingURL=index.js.map
